<template>
  <div>
    <add-individual-activity :is-active.sync="isAdding" @changed="individualActivityAdded" />
    <add-individual-activity
      :is-active.sync="isUpdating"
      method="put"
      :individualActivity="editingType"
      @changed="individualActivityUpdated"
    />
    <data-table title="Activity List" :url="url" :headers="headers" ref="table" searchable>
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          <v-icon color="light-blue lighten-4">
            mdi-plus-outline
          </v-icon>
          Add New Activity
        </v-btn>
      </template>
      <template slot="item.actions" slot-scope="{ item }">
        <div class="d-flex">
          <v-btn small icon @click.stop="updateActivity(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn small icon @click.stop="deleteActivity(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import AddIndividualActivity from "./form";

export default {
  components: { AddIndividualActivity },
  data() {
    return {
      isAdding: false,
      isUpdating: false,
      url: "/api/v1/individual-activities",
      editingType: null,
      headers: {
        name: "Name",
        is_visible: "Is Visible",
        "risk_score": "Risk score",
        actions: "Actions",
      },
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    individualActivityAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    individualActivityUpdated({ message }) {
      this.editingType = null;
      this.isUpdating = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    updateActivity(type) {
      this.editingType = Object.assign({}, type);
      this.isUpdating = true;
    },
    deleteActivity(activity) {
      Notify.confirm(`Please Confirm`).then(() => {
        this.$http
          .delete(`/api/v1/individual-activities/${activity.id}`)
          .then((result) => {
            Notify.success(result.message);
            window.location.reload();
          })
          // eslint-disable-next-line no-unused-vars
          .catch((error) => {
            Notify.error(error.message);
          });
      });
    },
  },
};
</script>
